import { useCallback, useEffect, useRef } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { trackVideoPlay } from '@/services/playTrackingService';
import { NoteOut } from '@/services/noteGoApi/noteGoApiSchemas';

interface UsePlayTrackingProps {
  note: NoteOut | null;
  isShared: boolean;
  shareToken?: string;
}

export const usePlayTracking = ({ note, isShared, shareToken }: UsePlayTrackingProps) => {
  const { userData } = useAuthStore();
  const hasTrackedRef = useRef(false);

  // The Note page stays mounted across note navigation, so reset the
  // once-per-note guard whenever the note changes.
  useEffect(() => {
    hasTrackedRef.current = false;
  }, [note?.id]);

  const trackPlay = useCallback(async () => {
    if (!note || hasTrackedRef.current) return;

    hasTrackedRef.current = true;

    await trackVideoPlay({
      noteId: note.id,
      noteOwnerId: note.creator_user_id,
      playerId: userData?.id,
      isShared,
      shareToken,
    });
  }, [note, userData?.id, isShared, shareToken]);

  return { trackPlay };
};
